/**
 * What the Reporting landing renders, as one decision:
 *
 *   loading  → skeleton panels, until every reporting request settles
 *              (the empty illustration never flashes while data is in flight)
 *   error    → a reporting request failed; the page says so rather than
 *              presenting a failed fetch as an account with no history
 *   empty    → every chart is below the visibility rule
 *   charts   → the charts that pass the rule, in page order
 */

export type ReportingChartId = "rewardsRate" | "earnings" | "balances";

export const REPORTING_CHART_ORDER: readonly ReportingChartId[] = ["rewardsRate", "earnings", "balances"];

export type ReportingPageState =
    | { kind: "loading" }
    | { kind: "error" }
    | { kind: "empty" }
    | { kind: "charts"; visible: ReportingChartId[] };

export function deriveReportingPageState({
    isLoading,
    hasError,
    chartHasHistory
}: {
    isLoading: boolean;
    hasError: boolean;
    chartHasHistory: Record<ReportingChartId, boolean>;
}): ReportingPageState {
    if (isLoading) return { kind: "loading" };
    if (hasError) return { kind: "error" };
    const visible = REPORTING_CHART_ORDER.filter((id) => chartHasHistory[id]);
    return visible.length === 0 ? { kind: "empty" } : { kind: "charts", visible };
}
